<ng-container *ngIf="type == 'hotel'; else extraPerson">
    <ng-container [ngTemplateOutlet]="counter" *ngIf="currentValue() > 0; else reserve"></ng-container>
</ng-container>

<ng-template #extraPerson>
    <div class="flex justify-between items-center w-full gap-2 p-2 border-2 border-solid rounded-lg mt-1">
        <div class="w-2/5 text-center" *ngIf="isMobile">انتخاب نفرات</div>
        <ng-container class="w-2/5" [ngTemplateOutlet]="counter" />
    </div>
</ng-template>

<ng-template #counter>
    <section class="flex items-center w-full gap-2 justify-between px-2">
        <div class="plus">
            <button (click)="increase()" [ngClass]="currentValue() === max ? 'disabled': 'active'"
                [style.width]="type == 'hotel' ? '44px' : '28px'" [style.height]="type == 'hotel' ? '44px' : '28px'"
                class="flex justify-center items-center flex-shrink-0 rounded-lg border border-red-500 bg-slate-200">
                <mat-icon matPrefix>
                    <i class="flex justify-center items-center ico-Add text-lg font-bold -mt-[2px]"
                        [ngClass]="currentValue() === max ? 'text-gray-500' : 'text-blue-500'"></i>
                </mat-icon>
            </button>
        </div>
        <div class="flex justify-center items-center w-full h-11 font-medium text-base">
            <ng-container *ngIf="type == 'hotel';else extraPerson">
                {{currentValue()}}
            </ng-container>
            <ng-template #extraPerson>
                <ng-content></ng-content>
            </ng-template>

        </div>
        <div class="minus">

            <button (click)="decrease()" [ngClass]="min == 1 && currentValue() - 1 <= 0 ? 'disabled': 'active'"
                [style.width]="type == 'hotel' ? '44px' : '28px'" [style.height]="type == 'hotel' ? '44px' : '28px'"
                class="flex justify-center items-center flex-shrink-0 rounded-lg border border-red-500 bg-slate-200"
                [disabled]="min == 1 && currentValue() - 1 <= 0">
                <mat-icon matPrefix>
                    <i class="flex justify-center items-center ico-Minus text-lg font-bold -mt-[1px]"
                        [ngClass]="currentValue() === min ? 'text-gray-500' : 'text-blue-500'"></i>
                </mat-icon>
            </button>
        </div>
    </section>
</ng-template>

<ng-template #reserve>
    <button mat-flat-button color="primary" (click)="outOfPackagePeriod == -1 ? increase() : null "
        class="w-full !h-11 !text-base font-semi-bold">
        انتخاب اتاق
    </button>
</ng-template>